import { FieldHasValue, ValidateField, ValidateNumberField, ExponentialToDecimal } from 'helpers/Validation';

export const AsFoundTestTableF39HmiInst1Formula = (formData) => FieldHasValue(formData.F21HmiLrv) ? '0% - '
    .concat(ValidateField(formData.F21HmiLrv))
    .concat(' ')
    .concat(ValidateField(formData.F115HmiengineeringUnits)) : '0%';

export const AsFoundTestTableF40HmiInst2Formula = (formData) => (FieldHasValue(formData.F22HmiUrv) && FieldHasValue(formData.F21HmiLrv)
    ? '50% - '.concat(ExponentialToDecimal(ValidateNumberField(formData.F21HmiLrv)
        + (ValidateNumberField(formData.F22HmiUrv) - ValidateNumberField(formData.F21HmiLrv)) * (0.5)))
        .concat(' ')
        .concat(ValidateField(formData.F115HmiengineeringUnits)) : '50%');

export const AsFoundTestTableF41HmiInst3Formula = (formData) => (FieldHasValue(formData.F22HmiUrv) ? '100% - '
    .concat(ValidateField(formData.F22HmiUrv))
    .concat(' ')
    .concat(ValidateField(formData.F115HmiengineeringUnits)) : '100%');

export const AsFoundTestTableF54DeviationEu1Formula = (formData) => FieldHasValue(formData.F1057AftTestSpeed1) && FieldHasValue(formData.F48HmiReading1)
    ? ExponentialToDecimal(Math.abs(ValidateNumberField(formData.F1057AftTestSpeed1) - ValidateNumberField(formData.F48HmiReading1))) : '';
export const AsFoundTestTableF55DeviationEu2Formula = (formData) => FieldHasValue(formData.F1058AftTestSpeed2) && FieldHasValue(formData.F49HmiReading2)
    ? ExponentialToDecimal(Math.abs(ValidateNumberField(formData.F1058AftTestSpeed2) - ValidateNumberField(formData.F49HmiReading2))) : '';
export const AsFoundTestTableF56DeviationEu3Formula = (formData) => FieldHasValue(formData.F1059AftTestSpeed3) && FieldHasValue(formData.F50HmiReading3)
    ? ExponentialToDecimal(Math.abs(ValidateNumberField(formData.F1059AftTestSpeed3) - ValidateNumberField(formData.F50HmiReading3))) : '';

export const FoundResultF102AftResultFormula = (formData) => {
    if (FieldHasValue(formData.F54DeviationEu1)
        && FieldHasValue(formData.F55DeviationEu2)
        && FieldHasValue(formData.F56DeviationEu3) && FieldHasValue(formData.F60ToleranceEu)) {
        if (Math.max(ValidateNumberField(formData.F54DeviationEu1), ValidateNumberField(formData.F55DeviationEu2), ValidateNumberField(formData.F56DeviationEu3))
            <= ValidateNumberField(formData.F60ToleranceEu)) {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
